module.exports = "/images/10K.webp?5bab7f6b2cba849eef1273aa4c6b31d9";